export default __webpack_public_path__ + "static/media/Hindi_dm_1.4d912267.mp3";